"use client"

import { useState } from "react"
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/Tabs"
import { useUser } from "@/utils/userContext/UserContext"
import "./MeuPerfil.css"

const MeuPerfil = () => {
  const [activeTab, setActiveTab] = useState("profile")
  const [isEditing, setIsEditing] = useState(false)
  const [editedName, setEditedName] = useState("")
  const [editedEmail, setEditedEmail] = useState("")
  const { userData } = useUser()

  const handleEdit = () => {
    if (!isEditing) {
      setEditedName(userData?.name || "")
      setEditedEmail(userData?.email || "")
      setIsEditing(true)
    } else {
      setEditedName(userData?.name || "")
      setEditedEmail(userData?.email || "")
      setIsEditing(false)
    }
  }

  return (
    <>
      <div className="perfil-header">
        <div>
          <h1 className="gradient-heading">Meu Perfil</h1>
          <p className="dashboard-page-subtitle">Atualize seus dados e preferências da conta.</p>
        </div>
      </div>

      <div className="perfil-tabs">
        <Tabs>
          <TabsList>
            <TabsTrigger active={activeTab === "profile"} onClick={() => setActiveTab("profile")}>
              Perfil
            </TabsTrigger>
          </TabsList>

          {activeTab === "profile" && (
            <TabsContent>
              <div className="profile-content">
                <div className="form-group" >
                  <label htmlFor="name">Nome</label>
                  <input
                    type="text"
                    id="name"
                    value={isEditing ? editedName : userData?.name || ""}
                    onChange={(e) => setEditedName(e.target.value)}
                    style={{backgroundColor: isEditing ? "#FFFFFF" : "#F5F5F5"}}
                    disabled={!isEditing}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="email">Email</label>
                  <input
                    type="email"
                    id="email"
                    value={isEditing ? editedEmail : userData?.email || ""}
                    onChange={(e) => setEditedEmail(e.target.value)}
                    style={{backgroundColor: isEditing ? "#FFFFFF" : "#F5F5F5"}}
                    disabled={!isEditing}
                  />
                </div>
                <div className="form-actions">
                  <button className="save-button" disabled={!isEditing} style={{display: "none"}}>Salvar</button>
                  <button
                    className="edit-button"
                    onClick={handleEdit}
                    style={{display: "none"}}
                  >
                    {isEditing ? "Cancelar" : "Editar"}
                  </button>
                </div>
              </div>
            </TabsContent>
          )}

          {activeTab === "account" && (
            <TabsContent>
              <div className="account-content">
                <p>Configurações da conta</p>
              </div>
            </TabsContent>
          )}

          {activeTab === "notifications" && (
            <TabsContent>
              <div className="notifications-content">
                <p>Preferências de notificação</p>
              </div>
            </TabsContent>
          )}

          {activeTab === "billing" && (
            <TabsContent>
              <div className="billing-content">
                <p>Informações de faturamento</p>
              </div>
            </TabsContent>
          )}
        </Tabs>
      </div>
    </>
  )
}

export default MeuPerfil
